import { TruncateToolTip } from "../../../../../utils/TruncateTooltip";

const RenderSLOContent = ({ row, column }) => {
  return (
    <div
      style={{
        lineHeight: 1,
        padding: "10px 2px",
        textWrap: "wrap",
        height: "100%",
      }}
    >
      <TruncateToolTip
        renderTip={<div style={{ maxWidth: 400 }}>{row[column.key]}</div>}
        maxLines={6}
      >
        {row[column.key]}
      </TruncateToolTip>
    </div>
  );
};

export default RenderSLOContent;
